import React from 'react';
import artlogo from '../assets/images/artlogo_sm.png'

export default function ArtIcon() {
  return (
    <>
        <img src={artlogo} alt="artlogo" />
    </>
  );
}